export const TOAST_STYLE = {
  success: 'success-toast',
  info: 'info-toast',
  danger: 'danger-toast',
};
